// extracted by mini-css-extract-plugin
module.exports = {"container":"pension-item_container__274mQ","wobble":"pension-item_wobble__3tmLZ","detail":"pension-item_detail__2nlR0","chart-img-div":"pension-item_chart-img-div__14iPR"};